<template>
  <div>
    <vca-column>
      <div v-if="getReceiverGroup">
        <vca-card class="shadowed">
          <AccountAspGroup v-model="current" ref="group" />
          <Email v-model="current" ref="email" />
        </vca-card>
        <vca-card class="shadowed">
          <Tips />
        </vca-card>
      </div>
    </vca-column>

    <button class="vca-button" @click="update()" :disabled="isInvalid">
      {{ $t("button.save") }}
    </button>
    <div class="vca-center">
      <vca-column class="vca-center">
        <button
          class="vca-button-small vca-center"
          :disabled="isInvalid"
          @click="preview = true"
        >
          {{ $t("button.preview") }} & {{ $t("button.send") }}
        </button>
      </vca-column>
    </div>

    <vca-popup
      v-if="preview"
      :show="preview"
      :title="$t('email.preview.title', { 0: current.subject })"
      @close="preview = false"
    >
      <EmailPreview :event="currentEvent" v-model="current" @send="send" />
    </vca-popup>
  </div>
</template>

<script>
import Email from "@/components/account/emails/form/AccountAspEmail";
import AccountAspGroup from "@/components/account/emails/form/AccountAspGroup";
import EmailPreview from "@/components/emails/EmailPreview";
import Tips from "@/components/emails/form/Tips";
import { mapGetters } from "vuex";
export default {
  name: "AccountAspEmailEdit",
  components: {
    Email,
    Tips,
    EmailPreview,
    AccountAspGroup,
  },
  data() {
    return {
      preview: false,
    };
  },
  created() {
    this.current.recipient_group.type = "event";
    this.$store
      .dispatch({
        type: "events/queryList",
        data: { id: [this.current.recipient_group.event_id] },
      })
      .then((response) => {
        this.$store.commit("user/aspevents/list", response);
        this.$store.commit("user/aspevents/pg/pageSize", response.length);
      });
    this.$store.commit("user/emails/mailbox/message/user_id", this.user.id);
  },
  methods: {
    update() {
      if (this.isInvalid) {
        this.$refs.receivers.validate();
        this.$refs.group.validate();
        this.$refs.email.validate();
      } else {
        this.$store.dispatch("user/emails/mailbox/message/update").then(() => {
          this.$store.dispatch("user/emails/mailbox/get");
        });
      }
    },
    send() {
      if (this.isInvalid) {
        this.preview = false;
        this.$refs.receivers.validate();
        if (this.getReceiverGroup == "event") {
          this.$refs.group.validate();
        }
        this.$refs.email.validate();
      } else {
        this.$store
          .dispatch("user/emails/mailbox/message/update")
          .then((response) => {
            this.$store.commit("user/emails/mailbox/message/current", response);
            this.$store
              .dispatch("user/emails/mailbox/message/send")
              .then(() => {
                this.$store.dispatch("user/emails/mailbox/get").then(() => {
                  this.$router.push({
                    path: "/account/asps/emails",
                  });
                });
              });
          });
      }
    },
  },
  computed: {
    current: {
      set(value) {
        this.$store.commit("user/emails/mailbox/message/current", value);
      },
      get() {
        return this.$store.state.user.emails.mailbox.message.current
          ? this.$store.state.user.emails.mailbox.message.current
          : { recipient_group: {} };
      },
    },
    isInvalid() {
      return this.$v.current.$invalid;
    },
    getReceiverGroup() {
      return this.current.recipient_group.type;
    },
    currentEvent() {
      const event = this.getEvent(this.current.recipient_group.event_id);
      return event;
    },
    ...mapGetters({
      user: "user/current",
      getEvent: "user/aspevents/getEvent",
      validation: "user/emails/mailbox/message/validations",
      hasSystemPermission: "user/roles/hasSystemPermission",
    }),
  },
  validations() {
    return this.validation;
  },
};
</script>
